import { LinkPlugin as LexicalLinkPlugin } from "@lexical/react/LexicalLinkPlugin";

import { validateUrl } from "../../rich-text-editor-helper";

export const LinkPlugin = () => {
  return <LexicalLinkPlugin validateUrl={validateUrl} />;
};
